export default __webpack_public_path__ + "static/media/logo.d331c63c.png";